"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSceneRoot = void 0;
const ValueObjects_1 = require("../ValueObjects");
const ObserverList_1 = require("./ObserverList");
const TransformNode_1 = require("./TransformNode");
function makeSceneRoot() {
    return new SceneRootImp();
}
exports.makeSceneRoot = makeSceneRoot;
class SceneRootImp {
    constructor() {
        this.observers = new ObserverList_1.ObserverList();
        this._defaultPosition = ValueObjects_1.Vector3.Zero();
        this._defaultRoation = ValueObjects_1.Quaternion.Identity();
        this._defaultScale = ValueObjects_1.Vector3.One();
        this._minScale = 0.01;
        this._maxScale = 10;
        this._id = "scene_root";
        this.applyDefaultData = (data) => {
            this._defaultPosition = ValueObjects_1.Vector3.FromArray(data.position);
            this._defaultRoation = ValueObjects_1.Quaternion.FromArray(data.rotation);
            this._defaultScale = new ValueObjects_1.Vector3(data.scale, data.scale, data.scale);
            this._maxScale = data.maxScale;
            this._minScale = data.minScale;
            this._id = data.id;
        };
        this.centerOnPoint = (point, durationMS, easeFn, onCompleted) => {
            const finalPosition = ValueObjects_1.Vector3.Subtract(this.transform.worldPosition, point);
            this.transform.lerp(durationMS, easeFn, finalPosition, undefined, undefined, onCompleted);
        };
        this.bumpScaleAboutPoint = (amount, worldPoint) => {
            const localPickOffset = this.transform.worldPointToLocal(worldPoint);
            const currentScale = this.transform.worldScale.x;
            let newScale = currentScale + amount;
            if (newScale < this.minScale) {
                newScale = this.minScale;
            }
            else if (newScale > this.maxScale) {
                newScale = this.maxScale;
            }
            this.transform.worldScale = new ValueObjects_1.Vector3(newScale, newScale, newScale);
            const worldPickOffset = this.transform.localPointToWorld(localPickOffset);
            const bump = ValueObjects_1.Vector3.Subtract(worldPoint, worldPickOffset);
            this.transform.worldPosition = ValueObjects_1.Vector3.Add(bump, this.transform.worldPosition);
        };
        this.lerpToDefault = (durationMS, easeFn, onCompleted) => {
            this.transform.lerp(durationMS, easeFn, this.defaultPosition, this.defaultRoation, this.defaultScale, onCompleted);
        };
        this.addObserver = (observer) => {
            this.observers.add(observer);
        };
        this.removeObserver = (observer) => {
            this.observers.remove(observer);
        };
        this.transform = TransformNode_1.makeTransformNode();
        this.transform.addObserver(this.observers.notify);
    }
    get defaultPosition() {
        return this._defaultPosition;
    }
    get defaultRoation() {
        return this._defaultRoation;
    }
    get defaultScale() {
        return this._defaultScale;
    }
    get minScale() {
        return this._minScale;
    }
    get maxScale() {
        return this._maxScale;
    }
    get id() {
        return this._id;
    }
}
